const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

export const sendFirebaseFCMToken = (payload) => {
    console.log("inside reset firebase token", payload)
    return axiosInstance.post(EndPoints.FIREBASE.CREATE, payload);
};

export const sendEmployeesNotification = (payload) => {
    return axiosInstance.post(EndPoints.FIREBASE.EMPLOYEE_NOTIFICATION, payload);
};

export const getEmployeesNotification = (payload) => {
    // return axiosInstance.get(EndPoints.FIREBASE.EMPLOYEE_NOTIFICATION_LISTS, payload);
    return axiosInstance.get(EndPoints.FIREBASE.EMPLOYEE_NOTIFICATION_LISTS, { params: { ...payload } });
};

export const updateEmployeesNotification = (payload) => {
    return axiosInstance.put(EndPoints.FIREBASE.UPDATE, payload);
};